"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSlug = void 0;
const getSlug = () => {
    var _a;
    try {
        const url = window.location.href;
        const regexUrl = url.match(/^(?:https?:\/\/)?(?:[^@\n]+@)?(?:www\.)?([^:\/\n?]+)/im);
        if (!regexUrl) {
            return '';
        }
        const subdomain = (_a = regexUrl[1]) === null || _a === void 0 ? void 0 : _a.split('.');
        return (subdomain === null || subdomain === void 0 ? void 0 : subdomain[0]) || '';
    }
    catch (error) {
        throw new Error('Error in try to get domain from url');
    }
};
exports.getSlug = getSlug;
